import type { Operator } from "@/src/types/components/operators/Operator";
import supabase from "$lib/services/db";

export async function getOperator(sponsoredBy: number, isLive: boolean): Promise<Operator | null> {
  if (!isLive) return null;

  if (!sponsoredBy) {
    console.error("No sponsored operator ID provided");
    return null;
  }

  try {
    const { data, error } = await supabase.from("operators").select("*").eq("id", sponsoredBy).single();

    if (error) throw error;
    return data as Operator;
  } catch (err) {
    console.error("Error fetching operator:", (err as Error).message);
    return null;
  }
}
